import Link from 'components/ui/AppLink';
import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import { ChannelSubscriptionWithPaymentInfo } from '../../../shared/types';
import { baseUrls } from '../../../utils/baseUrls.utils';
import ChannelSubscriptionCard from './ChannelSubscriptionCard';

import ArrowsChevronSmallRight from '@mds/icons/CaretRight';

interface SubscriptionsChannelsProps {
    channelSubscriptions: ChannelSubscriptionWithPaymentInfo[];
    onUpdate: () => void;
}

export const ChannelSubscriptionCards = ({
    channelSubscriptions,
    onUpdate,
}: SubscriptionsChannelsProps) => {
    if (channelSubscriptions.length === 0) {
        return (
            <Paper>
                <Box
                    sx={{
                        p: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography>You do not have any subscriptions.</Typography>
                    <Link
                        to={baseUrls.channels.main}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            '& svg': { width: 14, ml: 0.5 },
                        }}
                    >
                        Browse Channels <ArrowsChevronSmallRight />
                    </Link>
                </Box>
            </Paper>
        );
    }

    return (
        <>
            <Grid container spacing={2}>
                {channelSubscriptions.map((cs) => (
                    <Grid
                        key={cs.channel._id}
                        sx={{ display: 'flex' }}
                        size={{
                            xs: 12,
                            md: 4,
                        }}
                    >
                        <ChannelSubscriptionCard
                            subscription={cs}
                            onUpdate={onUpdate}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};
